export default __webpack_public_path__ + "static/media/sve.a0fd41ba.svg";